import { Component, OnDestroy, OnInit } from '@angular/core';
import { Location } from '@angular/common';

import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { DataService } from 'app/services';

@Component({
  selector: 'app-processing-dismiss-dialog',
  templateUrl: './processing-dismiss-dialog.component.html',
  styleUrls: ['./processing-dismiss-dialog.component.scss'],
  providers: [DialogService],
})
export class ProcessingDismissDialogComponent implements OnInit, OnDestroy {
  isLoading: boolean = true;
  timeInterval: any;
  headingTitle: string = '';
  message: string = '';
  isSuccess: boolean = false;
  dataServiceListeners: any[] = [];

  constructor(private dialogService: DialogService, private dynamicDialogConfig: DynamicDialogConfig, private dynamicDialogRef: DynamicDialogRef, private dataService: DataService) {}

  ngOnInit() {
    const { data } = this.dynamicDialogConfig;
    this.isLoading = true;
    if (data && data.headingTitle) {
      this.headingTitle = data.headingTitle;
    }
    if (data && data.message) {
      this.message = data.message;
    }

    this.setDataListner();
  }

  ngOnDestroy(): void {
    clearTimeout(this.timeInterval);
    this.dataServiceListeners.forEach((listener) => {
      try {
        listener.unsubscribe();
      } catch (err) {}
    });
  }

  setDataListner() {
    const listener = this.dataService.getData().subscribe(({ data }) => {
      console.log(data);
      if (data.key === 'processing-dismiss-succcess') {
        this.isLoading = false;
        this.isSuccess = true;
        this.processingDone(data.data);
      }
    });

    this.dataServiceListeners.push(listener);
  }

  async processingDone(data: any = {}) {
    try {
      setTimeout(() => {
        this.handleClose(true, data);
      }, 800);
    } catch (err) {
      console.log(err);
    }
  }

  handleClose(isSuccess: boolean = false, data: any = null) {
    this.dynamicDialogRef.close({ isSuccess, data });
  }
}
